<template>
  <section>
    <div class="modal-card">
      <header class="modal-card-head">
        <p>Respuestas</p>
      </header>
      <section class="modal-card-body">
          <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
           <b-table
              type="is-primary"
              :data.sync="Questions"
              :is-fullwidth="true"
              default-sort="name"
              aria-next-label="Next page"
              aria-page-label="Page"
              aria-current-label="Current page"
            >
              <template slot-scope="props">
                <b-table-column field="question" label="Pregunta" width="40"><b>{{ props.row.question }}</b></b-table-column>
                <b-table-column field="answer" label="Respuesta" width="40">{{ props.row.answer }}</b-table-column>
              </template>
              <template slot="empty">
                <section class="section">
                  <div class="content has-text-grey has-text-centered">
                    <p>
                      <b-icon icon="frown-open" size="is-large"></b-icon>
                    </p>
                    <p>Sin Respuestas</p>
                  </div>
                </section>
              </template>
            </b-table>
        <!-- <div v-for="question in Questions" :key="question.id">
          <b>{{question.question}}</b>
          {{question.answer}}
        </div> -->
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$parent.close()">Cerrar</button>
      </footer>
    </div>
  </section>
</template>
<script>
import { getAnswer } from "../../../services/answer";
export default {
  props: ["user_id", "questionary_id"],
  data() {
    return {
      Questions: [],
      isLoading:false,
    };
  },
  mounted: function () {
    this.chargeQuestions();
  },
  methods: {
    async chargeQuestions() {
      this.isLoading=true;
      await getAnswer(this.$http, this.questionary_id, this.user_id).then(
        (response) => {
          console.log(response, "RESPONSEE!");
          response.forEach((answer) => {
            // console.log(answer.alternative.questions_alternatives[0].question.question,'Pregutna')
            // console.log(answer.alternative.alternative,'Respuesta')
            this.Questions.push({
              id: answer.id,
              question:
                answer.alternative.questions_alternatives[0].question.question,
              answer: answer.alternative.alternative,
            });
          });
          this.isLoading=false;
        }
      );
    },
  },
};
</script>